import Step from "../../components/step/Step";
import { Box, SimpleGrid, Text, useRadioGroup } from "@chakra-ui/react";
import RadioCard from "../../components/radio-card/RadioCard";
import { useNavigate } from "react-router-dom";
import useStore from "../../storage/DataStore";
import maleBody1 from "../../assets/step5/target-male-1.png";
import maleBody2 from "../../assets/step5/target-male-2.png";
import maleBody3 from "../../assets/step5/target-male-3.png";
import maleBody4 from "../../assets/step5/target-male-4.png";
import femaleBody1 from "../../assets/step5/target-female-1.png";
import femaleBody2 from "../../assets/step5/target-female-2.png";
import femaleBody3 from "../../assets/step5/target-female-3.png";
import femaleBody4 from "../../assets/step5/target-female-4.png";
import { translation } from "../../utils/translation";

function Step6() {
  let navigate = useNavigate();

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "q6",
    onChange: () => {
      navigate("../step7", { replace: true });
    },
  });

  const state = useStore.getState();

  const options = [
    {
      id: "a2",
      icon: state.gender === "male" ? maleBody1 : femaleBody1,
      text: translation("general.step6.option1"),
    },
    {
      id: "a3",
      icon: state.gender === "male" ? maleBody2 : femaleBody2,
      text: translation("general.step6.option2"),
    },
    {
      id: "a4",
      icon: state.gender === "male" ? maleBody3 : femaleBody3,
      text: translation("general.step6.option3"),
    },
    {
      id: "a5",
      icon: state.gender === "male" ? maleBody4 : femaleBody4,
      text: translation("general.step6.option4"),
    },
  ];

  const group = getRootProps();

  return (
    <Step
      heading={translation("general.step6.headline")}
      currentStep={4}
      backLink={"/step4"}
    >
      <SimpleGrid mt={5} spacing={2} columns={1} {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value: value.id });
          return (
            <RadioCard key={value.id} {...radio}>
              <Box display={"flex"} alignItems={"center"}>
                <Box mr={5}>
                  <img height={100} width={100} src={value.icon} alt="" />
                </Box>
                <Text fontSize={"lg"} fontWeight={"bold"} mt={3}>
                  {value.text}
                </Text>
              </Box>
            </RadioCard>
          );
        })}
      </SimpleGrid>
    </Step>
  );
}

export default Step6;
